import { render, staticRenderFns } from "./EmptyList.vue?vue&type=template&id=f32c6cb6&scoped=true"
import script from "./EmptyList.vue?vue&type=script&lang=js"
export * from "./EmptyList.vue?vue&type=script&lang=js"
import style0 from "./EmptyList.vue?vue&type=style&index=0&id=f32c6cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c6cb6",
  null
  
)

export default component.exports